import { titleCase } from './SqliteHelp.js'
export function makeBindingsCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    return `/// Author: Samle
import 'package:get/get.dart';
import '../controllers/${tableName}_controller.dart';

class ${titleCase(tableName)}Binding extends Bindings {
  @override
  void dependencies() {
    Get.lazyPut<${titleCase(tableName)}Controller>(
      () => ${titleCase(tableName)}Controller(),
    );
  }
}
`
}